module.exports = __webpack_public_path__ + "static/img/zl_btn1.a575fa4.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/zl_btn1.png
// module id = +JYK
// module chunks = 7